import React, { Component } from 'react'
import { compose } from 'recompose'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { addLocaleData, IntlProvider } from 'react-intl'
import en from 'react-intl/locale-data/en'
import pt from 'react-intl/locale-data/pt'
import pickBy from 'lodash.pickby'

import App from '../../templates/App'
import AppGetCities from './App.getCities'
import AppGetLayers from './App.getLayers'
import AppGetTranslation from './App.getTranslation'
import { setTranslation } from '../../../services/Translation'
import { setSettings } from '../../../actions/settings'
import { setLayersData, setLayersLegends, setLayersKeys } from '../../../actions/layers'
import { setCitiesData } from '../../../actions/cities'
import { setDownloadsData } from '../../../actions/downloads'

addLocaleData(en)
addLocaleData(pt)

class AppContainer extends Component {
  constructor () {
    super()

    this.onChangeLanguage = this.onChangeLanguage.bind(this)
  }

  async componentDidUpdate () {
    const {
      getCities,
      getLayers,
      getTranslations,
      language,
      setCitiesData,
      setLayersData,
      setLayersLegends,
      setLayersKeys,
      setDownloadsData
    } = this.props

    const translations = getTranslations(language)
    const cities = getCities()
    const layers = getLayers()
    const layerLegends = pickBy(translations, (_value, key) => key.startsWith('legend.layer.'))
    const downloadsPage = pickBy(translations, (_value, key) => key.startsWith('download'))

    setCitiesData(cities)
    setTranslation(translations)
    setLayersData(layers)
    setLayersLegends(layerLegends)
    setDownloadsData(downloadsPage)
    setLayersKeys({})
  }

  async onChangeLanguage (language) {
    const { getTranslations, setSettings } = this.props

    const settings = getTranslations(language)

    setTranslation(settings)
    setSettings({ language })
  }

  render () {
    if (this.props.data.loading) {
      return null
    }

    return (
      <IntlProvider
        defaultLocale="pt-BR"
        locale={this.props.language || 'pt-BR'}
        key={this.props.language || 'pt-BR'}
        messages={this.props.getTranslations(this.props.language)}
      >
        <App
          {...this.props}
          onChangeLanguage={this.onChangeLanguage} />
      </IntlProvider>
    )
  }
}

const mapStateToProps = ({ settings }) =>
  (Object.assign({
    language: settings.language
  }))

const mapDispatchToProps = dispatch => bindActionCreators({
  setCitiesData,
  setLayersData,
  setLayersLegends,
  setLayersKeys,
  setDownloadsData,
  setSettings
}, dispatch)

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  AppGetTranslation,
  AppGetLayers,
  AppGetCities
)(AppContainer)



// WEBPACK FOOTER //
// ./src/components/pages/App/App.container.js